import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '@app/environment';
import { DemoozDateService, DemoozLocalStorageService } from '@demooz/services';
import { DataService } from '@app/services';

@Injectable({
  providedIn: 'root'
})
export class LanguagesService {
        
    defaultLanguage: string = 'fr';
    actualLanguage: string;   
    isTextsInitialized: boolean = false;
    
    constructor(
        private httpClient: HttpClient,
        private translateService: TranslateService,
        private demoozLocalStorageService: DemoozLocalStorageService,
        private dataService: DataService
    ) { }
        
    async initTexts(){   
        return new Promise ((resolve) => { 
        
            this.isTextsInitialized = false;                     
            let params: any = {
                lang: this.actualLanguage
            }
            
            if(this.dataService.operation.value){
                params.operationID = this.dataService.operation.value.ID
            }
            
            this.httpClient.get(environment.URL_API_BACKEND_REST+'i18n/get', {params: params}).subscribe(
                (response: any) => {                    
                    this.translateService.setTranslation(this.actualLanguage, response);
                    this.isTextsInitialized = true;
                    resolve(true);
                },
                () => {
                    resolve(false);
                }
            );
            
        });
    }
        
    async init (){   
             
        let language = this.translateService.getBrowserLang();     
        if(language === undefined){
            language = this.defaultLanguage;
        }                
        
        if(this.dataService.ambassador.value){
            let languageAmbassador = this.dataService.operation.languages.find(l => l.ID === this.dataService.ambassador.value.languageID);
            if(languageAmbassador){
                language = languageAmbassador.shortCode;
            }
        }
                
        await this.changeLanguage(language);        
        
    }
    
    translate(key: string|null): string{
        let text = '';
        if(key !== null && key != ''){
            text = this.translateService.instant(key);
        }        
        return text;
    }
        
    async changeLanguage(newLanguage: string){
        if(this.actualLanguage !== newLanguage){
            this.actualLanguage = newLanguage;
            await this.initTexts();
            this.translateService.setDefaultLang(this.actualLanguage); 
            this.translateService.use(this.actualLanguage);     
            DemoozDateService.SetMomentLocale(this.actualLanguage);  
        }
    }
    
}
